import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-mb-3" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-4" }
const _hoisted_4 = { class: "p-float-label" }
const _hoisted_5 = {
  for: "label",
  class: "kn-material-input-label"
}
const _hoisted_6 = { class: "p-field p-col-4" }
const _hoisted_7 = { class: "p-float-label" }
const _hoisted_8 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_9 = { class: "p-field p-col-4" }
const _hoisted_10 = { class: "p-float-label" }
const _hoisted_11 = {
  for: "type",
  class: "kn-material-input-label"
}
const _hoisted_12 = { class: "p-field p-col-12" }
const _hoisted_13 = { class: "p-float-label" }
const _hoisted_14 = {
  for: "desc",
  class: "kn-material-input-label"
}
const _hoisted_15 = {
  key: 2,
  class: "p-field p-col-6"
}
const _hoisted_16 = { class: "p-float-label" }
const _hoisted_17 = {
  for: "label",
  class: "kn-material-input-label"
}
const _hoisted_18 = {
  key: 3,
  class: "p-field p-col-6"
}
const _hoisted_19 = { class: "p-float-label" }
const _hoisted_20 = {
  for: "description",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_InputText = _resolveComponent("InputText")
  const _component_VCodeMirror = _resolveComponent("VCodeMirror")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Button, {
        label: _ctx.$t('managers.driversManagement.useModes.backToList'),
        icon: "pi pi-arrow-left",
        class: "p-button-text",
        style: {"width":"120px"},
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, null, 8, ["label"])
    ]),
    _createVNode("form", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("span", _hoisted_4, [
          _createVNode(_component_InputText, {
            id: "label",
            class: "kn-material-input",
            type: "text",
            modelValue: _ctx.selectedLov.label,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedLov.label = $event)),
            disabled: ""
          }, null, 8, ["modelValue"]),
          _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('common.label')), 1)
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("span", _hoisted_7, [
          _createVNode(_component_InputText, {
            id: "name",
            class: "kn-material-input",
            type: "text",
            modelValue: _ctx.selectedLov.name,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedLov.name = $event)),
            disabled: ""
          }, null, 8, ["modelValue"]),
          _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('common.name')), 1)
        ])
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("span", _hoisted_10, [
          _createVNode(_component_InputText, {
            id: "type",
            class: "kn-material-input",
            type: "text",
            modelValue: _ctx.selectedLov.itypeCd,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedLov.itypeCd = $event)),
            disabled: ""
          }, null, 8, ["modelValue"]),
          _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('common.type')), 1)
        ])
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode("span", _hoisted_13, [
          _createVNode(_component_InputText, {
            id: "desc",
            class: "kn-material-input",
            type: "text",
            modelValue: _ctx.selectedLov.description,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedLov.description = $event)),
            disabled: ""
          }, null, 8, ["modelValue"]),
          _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('common.description')), 1)
        ])
      ]),
      (_ctx.codeMirrorVisiable)
        ? (_openBlock(), _createBlock(_component_VCodeMirror, {
            key: 0,
            ref: "codeMirror",
            class: "p-mt-2",
            options: _ctx.options,
            value: _ctx.code,
            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.code = $event)),
            autoHeight: true
          }, null, 8, ["options", "value"]))
        : _createCommentVNode("", true),
      (this.selectedLov.itypeCd === 'FIX_LOV')
        ? (_openBlock(), _createBlock(_component_DataTable, {
            key: 1,
            value: _ctx.rows,
            class: "p-datatable-sm kn-table",
            responsiveLayout: "stack"
          }, {
            empty: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "VALUE",
                header: _ctx.$t('common.value'),
                class: "kn-truncated"
              }, null, 8, ["header"]),
              _createVNode(_component_Column, {
                field: "DESCRIPTION",
                header: _ctx.$t('common.description'),
                class: "kn-truncated"
              }, null, 8, ["header"])
            ]),
            _: 1
          }, 8, ["value"]))
        : _createCommentVNode("", true),
      (_ctx.selectedLov.itypeCd === 'DATASET' || _ctx.selectedLov.itypeCd === 'JAVACLASS')
        ? (_openBlock(), _createBlock("div", _hoisted_15, [
            _createVNode("span", _hoisted_16, [
              _createVNode(_component_InputText, {
                id: "label",
                class: "kn-material-input",
                type: "text",
                modelValue: _ctx.label,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.label = $event)),
                disabled: ""
              }, null, 8, ["modelValue"]),
              _createVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('common.label')), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.selectedLov.itypeCd === 'DATASET' || _ctx.selectedLov.itypeCd === 'JAVACLASS')
        ? (_openBlock(), _createBlock("div", _hoisted_18, [
            _createVNode("span", _hoisted_19, [
              _createVNode(_component_InputText, {
                id: "description",
                class: "kn-material-input",
                type: "text",
                modelValue: _ctx.name,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.name = $event)),
                disabled: ""
              }, null, 8, ["modelValue"]),
              _createVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('common.name')), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}